/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';

import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import styles from './ChartTableItem.module.scss';

@observer
export default class ChartTableItem extends React.Component<*> {
  render(): React.Element<*> {
    const linkTo: Object = {
      pathname: this.props.link,
      state: { user: { id: this.props.id } },
    };

    const item: any = this.props.link ? (
      <ListItem button={false} className={styles['chart-table-item']}>
        <Link to={linkTo}>
          {this.props.title}
          <ListItemSecondaryAction>
            <Typography variant="headline" className={styles['chart-item-btn']}>
              {this.props.action}
            </Typography>
          </ListItemSecondaryAction>
        </Link>
      </ListItem>
    ) : (
      <ListItem button={false} className={styles['chart-table-item']}>
        <span>{this.props.title}</span>
      </ListItem>
    );

    return item;
  }
}
